import baseAPI from "@/http";

const router = "api/geral/produto";

export const produtoAPI = {
  create: produto => baseAPI.post(router, produto),
  update: produto => baseAPI.put(router, produto),
  get: id => baseAPI.get(`${router}/${id}`),
  list: () => baseAPI.get(`${router}`),
  anunciosCadastrados: () => baseAPI.get(`${router}/anuncios-cadastrados`),
  listarProdutos: term => baseAPI.get(`${router}/busca/${term}`),
  listarProdutosFiltro: filtro =>
    baseAPI.post(`${router}/busca/filtro`, filtro),
  listarMeusProdutos: () => baseAPI.get(`${router}/meus-produtos`),
  delete: id => baseAPI.delete(`${router}/${id}`)
};
